import { toast } from "react-toastify"
import client from "../apollo/client"
import { signOut } from "./auth"
import log from "./log"

export const testVersion = (current, latest) => {
  const sCurrent = current.split(".")
  const sLatest = latest.split(".")
  if (sCurrent.length !== 3 || sLatest.length !== 3) {
    log("warn", [
      "AppUpdate: testVersion received invalid version numbers",
      { current, latest },
    ])
    return false
  }
  if (
    sLatest[0] > sCurrent[0] ||
    sLatest[1] > sCurrent[1] ||
    sLatest[2] > sCurrent[2]
  ) {
    log("log", [
      "AppUpdate: testVersion detected a new version",
      { current, latest },
    ])
    return true
  }
  return false
}

export const handleUpdate = newVersion => {
  const isReview =
    window.location.href.includes("compose/review") &&
    !window.location.href.includes("report")
  if (isReview) {
    log("warn", [
      `AppUpdate: a new update was found for version ${newVersion} but user is currently composing a review`,
      "Will not execute app update",
    ])
    return
  }
  // Alert user
  // alert(
  //   "Pardon the interruption.  A new version of Reflection App is available.  Please press OK to refresh the application and update to the latest version."
  // )
  // Log to tracking
  window.TrackJS &&
    window.TrackJS.track(
      `New version handler was executed for version ${newVersion}`
    )

  log("log", ["New version handler was executed for version", newVersion])

  // Update version
  window.localStorage.setItem("VERSION", newVersion)
  //Clear cache
  window.localStorage.removeItem("apollo-cache-persist")
  // Clear client store
  client.clearStore()
  // Clear service workers
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.unregister()
      }
    })
  }
  // Reload page
  toast("🎉 Reflection App has received an update!")
  setTimeout(() => {
    signOut("/a/login#updated")
  }, 5500)
}

export const checkForUpdates = latestVersion => {
  // checks the version
  const currentVersion = window.localStorage.getItem("VERSION") || "0.0.0"
  const isNewVersion =
    currentVersion === "0.0.0"
      ? false
      : testVersion(currentVersion, latestVersion)

  log("log", [
    "Checking for update with version:",
    { currentVersion, latestVersion, isNewVersion },
  ])

  if (isNewVersion) {
    handleUpdate(latestVersion)
  }

  window.handleUpdate = () => {
    handleUpdate(latestVersion)
  }

  //Always set latest version number
  window.localStorage.setItem("VERSION", latestVersion)
}
